import { TipoInputEnum } from "./tipoInput";

export const InputSmartFactoryEnum = {
    GanhoMediodeProdutividade: { idProgramaToInput: 89, nome: "Ganho Médio de Produtividade", id_tipo_input: TipoInputEnum.ValorUnico },
    GanhoMediodeOEE: { idProgramaToInput: 90, nome: "Ganho Médio de OEE", id_tipo_input: TipoInputEnum.ValorUnico },
    NumeroDeEmpresasValidadoras: { idProgramaToInput: 91, nome: "Número de Empresas Validadoras aprovado", id_tipo_input: TipoInputEnum.ValorInteiro },
    CNPJDaEmpresaValidadora: { idProgramaToInput: 92, nome: "CNPJ da Empresa Validadora", id_tipo_input: TipoInputEnum.Cnpj },
};